import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="w-full bg-primary-800 text-primary-100 mt-16">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-10">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-500 text-white">
                <i className="ri-movie-2-fill text-xl" aria-hidden="true" />
              </span>
              <span className="font-heading font-bold text-lg text-white">星辰影视</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-primary-200/90">
              汇聚丰富电影与电视剧内容信息，帮助你更快发现并了解热门影视作品。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-3">浏览</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="hover:text-accent-300 cursor-pointer">首页</Link></li>
              <li><Link to="/category?type=movie" className="hover:text-accent-300 cursor-pointer">电影</Link></li>
              <li><Link to="/category?type=tv" className="hover:text-accent-300 cursor-pointer">电视剧</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-3">探索</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/search?keyword=科幻" className="hover:text-accent-300 cursor-pointer">科幻片单</Link></li>
              <li><Link to="/search?keyword=悬疑" className="hover:text-accent-300 cursor-pointer">悬疑片单</Link></li>
              <li><Link to="/about" className="hover:text-accent-300 cursor-pointer">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-3">联系我们</h4>
            <ul className="space-y-2 text-sm text-primary-200/90">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line" aria-hidden="true" />
                <span>contact@xingchen-media.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line" aria-hidden="true" />
                <span>内容每日更新</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-700 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-primary-300/80">
          <p>© 2026 星辰影视 · 本站影视内容均为演示示例，仅用于信息展示。</p>
          <p>内容仅供参考，不提供在线播放与下载服务。</p>
        </div>
      </div>
    </footer>
  );
}